/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/helpers/app.helpers.error-handler.ts.
 */
import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {AppEventService} from '../services/app.event.service';
import {Router} from '@angular/router';
import {AppLogService} from '../services/app.log.service';
import {AppDialogsService} from '../services/app.dialogs.service';
import * as Sentry from '@sentry/angular';
import {SentryErrorHandler} from '@sentry/angular';
import {AppConfigService} from '../services/app.config.service';

declare let window: any;

/**
 * Zweck: Beschreibt class AppHelpersErrorHandler und ihren Daten- oder Funktionsvertrag.
 */
@Injectable()
export class AppHelpersErrorHandler implements ErrorHandler {
  dsvc: AppDialogsService;

  sentryErrorHandler: SentryErrorHandler | any;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private esvc: AppEventService, private injector: Injector, private logsvc: AppLogService,
              private cfg: AppConfigService) {
    this.dsvc = this.injector.get(AppDialogsService);
    this.sentryErrorHandler = Sentry.createErrorHandler({
      showDialog: false,
      logErrors: false,
    });
  }

/**
 * Beschreibt Methode handleError und ihren Rückgabevertrag.
 */
  handleError(error: any) {
    const router = this.injector.get(Router);
    // Do whatever you like with the error (send it to the server?)
    // And log it to the console

    if (error.message && error.message.match(/.*index_app\.html.*/) ||
      (error.message == 'Cannot read property \'match\' of null ' && error.stack.match('/.*android_asset.*/'))
    ) {
      router.navigateByUrl('/');

    } else {
      if (error.error && error.error.code) {
        if (error.error.code == 10001) {
          if (router.url != '/login') {
            router.navigateByUrl('/logout');
          }
        }
      } else {
        console.error(error);

        if (error.message.includes('ChunkLoadError')) {
          window.location.reload();
        }

        // this.logsvc.logError(error.message, window.location.href, error.stack, error);

        if (error.message.includes('NG04002')) {// 'Cannot match any routes')) {
          router.navigateByUrl('/error/not-found');
        }
      }
    }

    if (!this.cfg.isDebug()) {
      if (!(error.error && error.error.code) && error instanceof Error) {
        let skipSentry = false;
        if (error && error.message && error.message.includes('NG04002')) {
          skipSentry = true;
        }

        if (!skipSentry) {
          this.sentryErrorHandler.handleError(error);
        }
      }
    }
  }
}
